<template>
  <div class="col-12 d-flex">
    <div class="col-12">
      <div class="w-100 row align-items-center needs-command-center-area pb-3">
        <div class="section-title col-3 text-right">Core Concept</div>
        <div class="section-title col-3 text-center">Value Players (10)</div>
        <div class="section-title col-3 text-center">Player Icons</div>
        <div class="section-title col-3 text-center">Value Actions (12)</div>
      </div>
      <div class="w-100 row align-items-center pb-2" v-for="(question, idxQuestion) in this.questions" v-bind:key="idxQuestion" >
          <div class="col-3 text-right"><label>{{ displayQuestionName(question) }}</label></div>
          <div class="col-3 d-flex align-items-center">
            <template v-if="idxQuestion !== 7 && idxQuestion !== 10">
              <input v-model="playerObjectArray[idxQuestion].label" :class="{ 'value-player-default': playerObjectArray[idxQuestion].useDefault && !playerObjectArray[idxQuestion].edited }" @input="playerObjectArray[idxQuestion].edited = true" :placeholder="playerObjectArray[idxQuestion].useDefault && !playerObjectArray[idxQuestion].edited ? getDefaultPlayerLabel(question) : ''" :id="`playerLabel-${idxQuestion}`" :name="`playerLabel-${idxQuestion}`" type="text" class="form-control" />
            </template>
          </div>
          <div class="col-3 text-center">
            <template v-if="idxQuestion !== 7 && idxQuestion !== 10">
              <button type="button" class="btn btn-secondary bg-light" id="importIconButton" @click="openIconModal(playerOrdinal(idxQuestion))">
                <span class="ml-auto">
                    <font-awesome-icon :icon="['fa', 'upload']" /> Icon
                </span>
              </button>
              <span v-if="playerObjectArray[idxQuestion]?.icon" class="ml-2 align-middle">
                <img :src="playerObjectArray[idxQuestion].icon" width="35" height="30" class="rounded" />
              </span>
            </template>
          </div>
          <div class="col-3 d-flex align-items-center">
            <input v-model="playerMappingObjectArray[idxQuestion].actionText" :class="{ 'value-player-default': playerMappingObjectArray[idxQuestion].useDefault && !playerMappingObjectArray[idxQuestion].edited }" @input="playerMappingObjectArray[idxQuestion].edited = true" :placeholder="playerMappingObjectArray[idxQuestion].useDefault && !playerMappingObjectArray[idxQuestion].edited ? defaultValueActions[idxQuestion] : ''" :id="`playerMapping-${idxQuestion}`" :name="`playerMapping-${idxQuestion}`" type="text" class="form-control" />
          </div>
      </div>
      <div class="w-100 form-row">
        <div class="col">
          <button type="submit" class="btn btn-primary float-right mt-1 mr-2" @click="saveValuePlayers()">
            <span>Save</span>
            <span v-show="this.$root.getLoading()" class="spinner-border spinner-border-sm"></span>
          </button>
        </div>
      </div>
    </div>
    
    <import-value-player-icon @icon-selected="onIconSelected" :row-index="activeRowIndex" :value-player-icon-options="valuePlayerIconOptions"/>
  </div>
</template>
<script>
import SectionMixins from "../mixins/SectionMixins.vue";
import ContentMixins from "../mixins/ContentMixins.vue";
import ErrorService from "../services/error.service";
import NeedsService from "../services/needs.service";
import AdminService from "../services/admin.service";
import ValuePlayerService from "../services/value.player.service";
import ImportValuePlayerIcon from "../modals/ImportValuePlayerIcon.vue";
export default {
  name: "ValuePlayerSection",
  mixins: [SectionMixins, ContentMixins],
  components: {
    ImportValuePlayerIcon
  },
  data() {
    return {
      questionName: "",
      segment_options: [],
      saved_segment_options: [],
      activeRowIndex: null,
      valuePlayerIconOptions: [],
      // Icon paths in core-concept row order; empty entries are action-only rows.
      defaultValuePlayerIcons: [
        "/img/value-player/money-magnet.png",
        "/img/value-player/money-paywall.png",
        "/img/value-player/truck-fast.png",
        "/img/value-player/puzzle-apart.png",
        "/img/value-player/buildings-downtown.png",
        "/img/value-player/person-single.png",
        "/img/value-player/decision-equal.png",
        "",
        "/img/value-player/campus-teaching.png",
        "/img/value-player/truck-forklift.png",
        "",
        "/img/value-player/team-together.png"
      ],
      // Label defaults in core-concept row order, matching defaultValueActions.
      defaultValuePlayers: [
        "Pricing Practices", "Ordering System", "Transportation", "Supplier Ecosystem",
        "Leadership/Sales", "Customers", "Choices/ Competitors", "",
        "Marketing", "Warehouses", "", "Human Resources"
      ],
      // Temporary action defaults in core-concept row order; edit these as needed.
      defaultValueActions: [
        "Pays", "Orders", "Delivers", "Configures",
        "Builds", "Designs", "Competes", "Sells",
        "Educates", "Communicates", "Supports", "Recruits"
      ],
      playerObjectArray: {
        type: Array,
        default: function() {
          return [{sequenceNumber:'', label:'', icon:'', playerNodeIconId:''}];
        }
      },
      playerMappingObjectArray: {
        type: Array,
        default: function() {
          return [{valuePlayerMappingTypeId:'', action:'', sequenceNumber: '', questionId: ''}];
        }
      },
      playerNodes: {
        type: Array,
        default: function() {
          return [];
        }
      },
    };
  },
  props: {
    surveyId: {
      type: Number,
      default: 0
    },
    valuePlayers: {
      type: Array,
      default: () => []
    },
    valuePlayerMapping: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    applyDefaultPlayerIcons() {
      if (!Array.isArray(this.playerObjectArray)) return;
      this.playerObjectArray.forEach((player, index) => {
        if (index === 7 || index === 10) return;
        const path = player.icon || this.defaultValuePlayerIcons[index];
        const icon = this.valuePlayerIconOptions.find(option => player.valuePlayerIconId
          ? String(option.valuePlayerIconId) === String(player.valuePlayerIconId)
          : path && option.imagePath === path);
        if (icon) {
          player.icon = icon.imagePath;
          player.valuePlayerIconId = icon.valuePlayerIconId;
        }
      });
    },
    getDefaultPlayerLabel(question) {
      return this.defaultValuePlayers[Number(question.designViewSequenceNumber) - 1] ?? '';
    },
    initializePlayerRows() {
    const previousRows = Array.isArray(this.playerObjectArray) ? this.playerObjectArray : [];
    this.playerObjectArray = this.questions.map((q, i) => {
      const seq = this.playerOrdinal(i);
      const iconDraft = previousRows.find(player => player.sequenceNumber === seq && player.iconEdited);
      const draft = previousRows.find(player => player.sequenceNumber === seq && player.edited);
      const match = (this.valuePlayers || []).find(v => String(v.sequenceNumber ?? v.id) === String(seq));
      return {
        sequenceNumber: seq,
        label: draft ? draft.label : (match?.label ?? this.getDefaultPlayerLabel(q)),
        edited: Boolean(draft),
        useDefault: match?.label == null,
        name: 'Player ' + seq,
        icon: iconDraft?.icon || match?.icon || match?.valuePlayerIcon?.imagePath || '',
        valuePlayerIconId: iconDraft?.valuePlayerIconId || match?.valuePlayerIconId || match?.valuePlayerIcon?.valuePlayerIconId || '',
        iconEdited: Boolean(iconDraft)
      };
    });
    this.applyDefaultPlayerIcons();
    },
    initializeMappingRows() {
    const previousRows = Array.isArray(this.playerMappingObjectArray) ? this.playerMappingObjectArray : [];
    this.playerMappingObjectArray = [...this.questions]
                                    .sort((a, b) => a.designViewSequenceNumber - b.designViewSequenceNumber)
                                    .map((q, i) => {
      const mappingSeq = this.actionOrdinal(i);
      const draft = previousRows.find(mapping => mapping.valuePlayerMappingTypeId === mappingSeq && mapping.edited);
      const qId = q.questionId;
      const mappingMatch = (this.valuePlayerMapping || []).find(v => String(v.id ?? v.valuePlayerMappingTypeId) === String(mappingSeq));
      const savedAction = mappingMatch && Object.prototype.hasOwnProperty.call(mappingMatch, 'action')
        ? mappingMatch.action : mappingMatch?.actionText;
      return {
        valuePlayerMappingTypeId: mappingSeq,
        actionText: draft ? draft.actionText : (savedAction ?? this.defaultValueActions[i] ?? ''),
        edited: Boolean(draft),
        useDefault: savedAction == null,
        questionId: qId
      };
    });
    },
    playerOrdinal(i) {
        const exclude = new Set([7, 10]); // exclusions for nodes block
        let n = 0;
        for (let k = 0; k <= i; k++) {
          if (!exclude.has(k)) n++;
        }
        return n;
    },
    actionOrdinal(i) {
        return i + 1;
    },
    displayQuestionName: function(questionObj){
      if (this.sectionObject.sectionType.name == "Functional Needs"){
        return NeedsService.getFunctionalNeedsDisplayName(questionObj);
      }
      return this.questionName;
    },
    saveValuePlayers() {
      this.playerNodes = this.playerObjectArray
        .filter((_, i) => i !== 7 && i !== 10)
        .map(p => {
          const iconObj = (this.valuePlayerIconOptions || [])
            .find(o => String(o.valuePlayerIconId) === String(p.valuePlayerIconId));

          return {
            sequenceNumber: p.sequenceNumber,
            label: p.label,
            name: p.name,
            valuePlayerIcon: iconObj || null
          };
        });
      const mappings = this.playerMappingObjectArray.map(({ valuePlayerMappingTypeId, actionText, questionId }) => ({
        valuePlayerMappingTypeId, actionText, questionId
      }));
      ValuePlayerService.saveValuePlayers(this.playerNodes, mappings, this.surveyId, this.saveValuePlayerNodesCallback, this);
    },
    saveValuePlayerNodesCallback(response){
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        const apiData = response.data.data || [];

        // Update playerObjectArray in place
        this.playerObjectArray = this.playerObjectArray.map(player => {
          player.useDefault = false;
          const match = apiData.find(item => String(item.sequenceNumber ?? item.sequenceNo) === String(player.sequenceNumber));
          if (match) {
            return { ...player, label: match.label || '', valuePlayerIconId: match.valuePlayerIcon?.valuePlayerIconId || '', icon: match.valuePlayerIcon?.imagePath || '' };
          }
          return player;
        });
        this.playerMappingObjectArray.forEach(mapping => {
          mapping.useDefault = false;
        });
        AdminService.displaySuccessMessage({ text: response.data.message });
      } else {
        ErrorService.processError("ValuePlayerService.saveValuePlayerNodesCallback", response.data.message, "survey-designer", this);
      }
    },  
    openIconModal: function(rowIdx) {
      this.activeRowIndex = rowIdx;
      this.$modal.show("value-player-icons-list");
    },
    onIconSelected({ rowIndex, icon }) {
      // Update all rows that match the sequenceNumber
      this.playerObjectArray.forEach(p => {
        if (Number(p.sequenceNumber) === Number(rowIndex)) {
          p.icon = icon.imagePath;
          p.valuePlayerIconId = icon.valuePlayerIconId;
          p.iconEdited = true;
        }
      });
    },
    getAllValuePlayerIconsCallback: function (response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.valuePlayerIconOptions = response.data.data;
        this.applyDefaultPlayerIcons();
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    }, 
  },
  created() {
    this.questions = [...this.questions].sort((a, b) => a.designViewSequenceNumber - b.designViewSequenceNumber);
    this.initializePlayerRows();
    this.initializeMappingRows();
  },
  async mounted() {
    if (this.sectionObject.sectionType.name == "Functional Needs"){
      this.questions.sort(function(a, b) {
        let positionA = a.designViewSequenceNumber;
        let positionB = b.designViewSequenceNumber;
        return positionA - positionB;
      });
    }
    await ValuePlayerService.getAllValuePlayerIcons(this.getAllValuePlayerIconsCallback, this);
  },
  watch: {
    valuePlayers: {
      deep: true,
      handler() {
        this.initializePlayerRows();
      }
    },
    valuePlayerMapping: {
      deep: true,
      handler() {
        this.initializeMappingRows();
      }
    }
  }
};
</script>

<style scoped>
.value-player-default {
  color: #999;
}
</style>
